import React from 'react';
import { useTranslation } from 'react-i18next';
import { transformDateString } from '@/utilities/datetime';
import styles from './Sidebar.module.scss';

export const DateText: React.FC<{ label: string }> = ({ label }) => {
  return (
    <div
      className={styles.dateText}
      data-cy="SideBar-atom__date"
    >
      {transformDateString(label, 'DD/MM/YYYY')}
    </div>
  );
};

export const Heading: React.FC<{ label: string }> = ({ label }) => {
  return (
    <div
      className={styles.headingText}
      data-cy="SideBar-header"
    >
      {label}
    </div>
  );
};

export const ItemBrand: React.FC<{ label: string }> = ({ label }) => {
  return (
    <div
      className={styles.itemBrand}
      data-cy="SideBar-atom__brand"
    >
      {label}
    </div>
  );
};

export const ItemName: React.FC<{ label: string }> = ({ label }) => {
  return (
    <div
      className={styles.itemName}
      data-cy="SideBar-atom__name"
    >
      {label}
    </div>
  );
};

export const SubTitle: React.FC<{ label: string }> = ({ label }) => {
  return (
    <div
      className={styles.subTitle}
      data-cy="SideBar-atom__subtitle"
    >
      {label}
    </div>
  );
};

export const Title: React.FC<{ label: string }> = ({ label }) => {
  return (
    <div
      className={styles.title}
      data-cy="SideBar-atom__title"
    >
      {label}
    </div>
  );
};

export const ShowMore: React.FC<{ onClick: () => void; disabled?: boolean }> = ({ onClick, disabled }) => {
  const { t } = useTranslation();
  return (
    <button
      className={styles.showMore}
      disabled={disabled}
      onClick={onClick}
      data-cy="SideBar-showMore"
    >
      {disabled ? t('common.loading').toUpperCase() : t('sidebar.show_more')}
    </button>
  );
};
